import React from 'react'
import { Typography, Box, IconButton, Grid , Button} from '@mui/material';
import { styled } from '@mui/system';
import bannerVideo from '../../assets/videos/openlmisBanner.mp4';
import { Link } from "react-router";


const BackgroundContainer = styled(Box)({
  position: 'relative',
  height: '100vh',
  overflow: 'hidden',
  color: '#fff',
});

const VideoBackground = styled('video')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: -1,
});

const Overlay = styled(Box)({
  position: 'relative',
  padding: '1rem',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  zIndex: 1,
});

function OpenLmisHome() {
  return (
    <div className='openLmishome'>
      <BackgroundContainer className="homeBackgroundContainer" id="home">
        {/* Video Background */}
        <VideoBackground autoPlay muted loop playsInline>
          <source src={bannerVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </VideoBackground>

        {/* Content Overlay */}
        <Overlay>
          <Grid container>
            <Grid size={{xs:12 , md:10}}>
              <Typography
                variant="h3"
                fontWeight="bold"
                sx={{
                  fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                  lineHeight: 1.3,
                  maxWidth: '100%',
                  marginBottom: '10px'
                }}
              >
                OPENLMIS
              </Typography>
              <Typography
                variant="h4"
                fontWeight="300"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.5rem', md: '1.8rem' },
                  lineHeight: 1.2,
                  maxWidth: '100%',
                //   wordBreak: 'break-word'
                }}
              >
                  Digital supply chain platforms enhance efficiency, accountability at
                  and availability of essential commodities through real-time data
                  and interoperability. Dure Technologies is a pioneer in delivering
                  such solutions for governments and the private sector.
              </Typography>

              
              <Link to="https://devapp.lmis.digitaltransformationcar.org/#!/home" target="_blank" rel="noopener noreferrer">
               <Button
              variant="contained"
              style={{
                borderRadius: 50,
                backgroundColor: "#c06fff",
                marginTop:"20px",
                textTransform:"capitalize",
                fontSize:"1rem",
                padding:"10px 40px",
                fontWeight:"300",
                width:"200px"
              }}
            > Login</Button>
            </Link>
           
            </Grid>
            <Grid size={{xs:12 , md:5}}></Grid>
          </Grid>
        </Overlay>
      </BackgroundContainer>
    </div>
  )
}

export default OpenLmisHome
